import React from 'react';
import Hero from './components/admission-broucher/Hero';
import Main from './components/admission-broucher/Main';

const AdmissionBroucher = () => {
  return (
    <div>
        <Hero/>
        <Main/>
    </div>
  )
}

export default AdmissionBroucher;